export default __webpack_public_path__ + "static/media/dep.9f8495a4.png";